import { render } from "./logo_logotyp_color.vue?vue&type=template&id=aa75292a&scoped=true"
import script from "./logo_logotyp_color.vue?vue&type=script&lang=js"
export * from "./logo_logotyp_color.vue?vue&type=script&lang=js"

import "./logo_logotyp_color.vue?vue&type=style&index=0&id=aa75292a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa75292a"]])

export default __exports__